


export type FlowRoleCostCentreScopeMode = 'All' | 'Selected';

export const FlowRoleCostCentreScopeMode = {
    All: 'All' as FlowRoleCostCentreScopeMode,
    Selected: 'Selected' as FlowRoleCostCentreScopeMode
};

